import React, { useEffect, useState } from "react";
import ConfirmationDlg from "../ConfirmationDlg";
import NormalSelect from "../form/HorizontalNormalSelect";



export const SorterForm = ({ onChange,fields=[] }) => {
 
  const [selectedSort, setSelectedSort] = useState('');
  const [selectedOrder, setSelectedOrder] = useState('asc');
  const [open, setOpen] = useState(false);

  const handleSelect = () => {
    if (!selectedSort) {
      onChange('')
    } else {
      onChange(`${selectedSort},${selectedOrder}`);
    }
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <>
      <button
        onClick={() => {
          setOpen(true);
        }}
        className="btn btn-outline-theme w-100"
      >
        {!selectedSort && "- Sort by - (None)"}
        {selectedSort && `- Sort by : ${selectedSort.replace('_',' ')} (${selectedOrder}) - `}
      </button>
      <ConfirmationDlg
        title={"Sort by"}
        open={open}
        onClose={handleClose}
        onSubmit={handleSelect}
        btnSubmitText={"Submit"}
        btnCancelText={"Cancel"}
      >

        <NormalSelect
          label="Sort by"
          list={fields.map((field) => ({
            name: field.replace('_',' '),
            id: field,
          }))}
          valueKey={'id'}
          value={selectedSort}
          onchange={(e) => setSelectedSort(e.target.value)}
        />


        <NormalSelect
          label="Order"
          list={['asc','desc'].map((order) => ({
            name: order,
            value: order,
          }))}
          value={selectedOrder}
          onchange={(e) => setSelectedOrder(e.target.value)}
        />
      
      </ConfirmationDlg>
    </>
  );
};
